<template>
    <div class="container-fluid bg-light h-100-vh">


        <!-- end page title -->



        <div class="row">
            <div class="col-md-4 col-sm-4 col-lg-4">

                <div class="card mt-1">

                    <div class="card-body">
                        <a class="text-primary"><i class="fas fa-caret-left"></i> Back</a>
                        <h1 class="font-weight-bolder">Payment</h1>
                    </div>

                </div>
                <div class="card">

                    <div class="card-body">
                        <div class="row">
                            <div class="col-2">
                                <i class="bi bi-person"></i>
                            </div>
                            <div class="col-8">
                                <h5>Molel Levy</h5>
                                <p>1C, Amani plaza,Chief's Rd Kinoo, Kiambu, Kenya</p>
                            </div>
                            <div class="col-2">
                                <i class="fas fa-angle-right"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <i class="bi bi-tag"></i>
                            </div>
                            <div class="col-8">
                                <h5>Apply Discount</h5>
                                <p>1C, Amani plaza,Chief's Rd Kinoo, Kiambu, Kenya</p>
                            </div>
                            <div class="col-2">
                                <i class="fas fa-angle-right"></i>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
            <div  class="col-md-8 col-sm-8 col-lg-8">
                <div class="card mt-1">
                    <div class="card-body">
                       <div class="text-center"><h2>Select Payment Method</h2></div>
                    </div>

                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <div class="float-left"><h5 class="pt-3">Pay</h5></div>
                            </div>
                            <div class="col-6">
                                <div class="float-right"><h1 class="">Kshs. 500.00 </h1><hr/></div>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="d-inline">
                    <div class="row">
                       <div class="col-4">
                           <button class="btn btn-primary btn-block">Card</button>
                       </div>
                       <div class="col-4">
                           <button class="btn btn-primary btn-block">Mpesa</button>
                       </div>
                       <div class="col-4">
                           <button class="btn btn-primary btn-block">Cash</button>
                       </div>
                    </div>
                </div>

                <div class="card mt-3">
                    <div class="card-body">

                        <div class="container-fluid d-inline">
                            <div class="float-left"><p>Sub total</p></div>
                            <div class="float-right"><p>KShs. 2000</p></div>
                        </div>
                        <hr/>
                        <div class="container-fluid d-inline">
                            <div class="float-left"><p>Discount</p></div>
                            <div class="float-right"><p>Kshs. 0</p></div>
                        </div>
                        <hr/>
                        <div class="container-fluid d-inline">
                            <div class="float-left"><p>Tax</p></div>
                            <div class="float-right"><p>Kshs. 100.00</p></div>
                        </div>


                        <hr/>
                        <div class="float-left"><h6 class="font-weight-bolder">Grand Total</h6></div>
                        <div class="float-right"><h6 class="font-weight-bolder">KShs. 2000</h6></div>
                    </div>

                </div>

            </div>




        </div>



    </div>

</template>

<script>
    export default {
        name: "paymentpage"
    }
</script>

<style scoped>

</style>